import { render, staticRenderFns } from "./EditCulvertInspection.vue?vue&type=template&id=08016c06&scoped=true"
import script from "./EditCulvertInspection.vue?vue&type=script&lang=ts"
export * from "./EditCulvertInspection.vue?vue&type=script&lang=ts"
import style0 from "./EditCulvertInspection.vue?vue&type=style&index=0&id=08016c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08016c06",
  null
  
)

export default component.exports